import { render, staticRenderFns } from "./Snow.vue?vue&type=template&id=00b9ffdd"
import script from "./Snow.vue?vue&type=script&lang=js"
export * from "./Snow.vue?vue&type=script&lang=js"
import style0 from "./Snow.vue?vue&type=style&index=0&id=00b9ffdd&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports